import { render } from "./AddCompany.vue?vue&type=template&id=89daf230&scoped=true"
import script from "./AddCompany.vue?vue&type=script&lang=js"
export * from "./AddCompany.vue?vue&type=script&lang=js"

import "./AddCompany.vue?vue&type=style&index=0&id=89daf230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89daf230"]])

export default __exports__